<header class="app-header">
  <div class="brand">
    <img
      class="brand-logo-img"
      [class.brand-logo-pedrogil]="selectedBrand === 'pedrogil'"
      [src]="currentLogo"
      [alt]="selectedBrand"
      [title]="selectedBrand" />
    <div class="brand-divider"></div>
    <div class="brand-text">
      <span class="brand-title">Screw Blower Selection Tool</span>
    </div>
  </div>

  <button class="mobile-menu-btn" (click)="onToggleSidenav()" type="button">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="header-right">
    <a
      class="manual-download-btn"
      href="assets/docs/Robuschi_Selection_Tool_User_Manual.pdf"
      download="Robuschi_Selection_Tool_User_Manual.pdf"
      target="_blank"
      rel="noopener"
      [title]="'NAV.DOWNLOAD_MANUAL' | translate"
      [attr.aria-label]="'NAV.DOWNLOAD_MANUAL' | translate">
      <app-icon name="download" [size]="14"></app-icon>
      <span class="manual-download-label">{{ 'NAV.USER_MANUAL' | translate }}</span>
    </a>

    <div class="header-divider"></div>

    <div class="lang-select-wrap">
      <img class="lang-globe" src="assets/icons/lang-globe.svg" width="13" height="13" alt="" />
      <select class="lang-select" [(ngModel)]="selectedLanguage" (ngModelChange)="changeLanguage($event)">
        <option *ngFor="let lang of filteredLanguages; trackBy: trackByLangCode" [value]="lang.code">{{ lang.label }}</option>
      </select>
    </div>

    <div class="header-divider"></div>

    <button type="button" class="user-menu-wrap" (click)="toggleUserMenu()">
      <div class="profile-avatar">
        <span>{{ profileInitials }}</span>
      </div>
      <span class="profile-name">{{ profileName }}</span>
      <app-icon name="chevron-down" [size]="12" class="user-menu-chevron"></app-icon>
    </button>

    <div class="user-dropdown" *ngIf="showUserMenu">
      <div class="user-dropdown-info">
        <div class="ud-avatar">{{ profileInitials }}</div>
        <span class="ud-name">{{ profileName }}</span>
      </div>
      <div class="user-dropdown-divider"></div>
      <div class="brand-section-label">Brand</div>
      <button
        *ngFor="let b of brands; trackBy: trackByBrandCode"
        type="button"
        class="brand-option-btn"
        [class.brand-option-active]="selectedBrand === b.code"
        (click)="changeBrand(b.code); $event.stopPropagation()">
        <span>{{ b.label }}</span>
        <svg
          *ngIf="selectedBrand === b.code"
          class="brand-check"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </button>
      <div class="user-dropdown-divider"></div>
      <button type="button" class="logout-btn" (click)="logout()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        {{ 'USER.LOGOUT' | translate }}
      </button>
    </div>
  </div>
</header>

<div class="menu-backdrop" *ngIf="showUserMenu" tabindex="-1" (click)="showUserMenu = false" (keydown.escape)="showUserMenu = false"></div>
